export enum Role {
	Guest = "guest",
	Scheduler = "scheduler",
}

export interface Profile {
	role: Role;
	hasRole: (...roles: Role[]) => boolean;
}
